import EditorComponent from "../../modules/creatives/editor";

export default function Editor() {
    return <EditorComponent role="organization" />;
}